import { create } from 'zustand';
import type { FeatureStore } from './FeatureStore.consts';
import { apiClient } from '@/services/apiClientSDK';
import type { FeatureDto } from '@user1st/api-client';

export const useFeatureStore = create<FeatureStore>((set, get) => ({
  features: [],
  fetchFeatures: (): void => {
    if (get().features.length > 0) return;

    apiClient.api.featureControllerFindAllActiveV1().then((features: FeatureDto[]) => {
      set({ features });
    });
  },
}));
